!function() {
  var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, t = {}, o = {}, i = e.parcelRequire5f74;
  null == i && ((i = function(e) {
    if (e in t) return t[e].exports;
    if (e in o) {
      var i = o[e];
      delete o[e];
      var n = {
        id: e,
        exports: {}
      };
      return t[e] = n, i.call(n.exports, n, n.exports), n.exports;
    }
    var s = new Error("Cannot find module '" + e + "'");
    throw s.code = "MODULE_NOT_FOUND", s;
  }).register = function(e, t) {
    o[e] = t;
  }, e.parcelRequire5f74 = i), (0, i.register)("jqqn3", function(e, t) {
    var o, i, n, s;
    function r(e, t = 5e3) {
      return new Promise((o, i) => {
        const n = Date.now(), s = setInterval(() => {
          window[e] ? (clearInterval(s), o(window[e])) : Date.now() - n >= t && (clearInterval(s), 
          i(new Error(`'${e}' did not become available within ${t}ms.`)));
        }, 100);
      });
    }
    o = e.exports, i = "waitForGlobal", n = function() {
      return r;
    }, Object.defineProperty(o, i, {
      get: n,
      set: s,
      enumerable: !0,
      configurable: !0
    });
  });
  var n = i("jqqn3");
  (() => {
    if (!customElements.get("cookie-banner")) {
      class e extends HTMLElement {
        constructor() {
          super(), this.isPreview = !1, this.acceptEl = this.querySelector("button[data-oz-accept]"), 
          this.preferencesEl = this.querySelector("button[data-oz-preferences]"), this.close = this.close.bind(this), 
          this.show = this.show.bind(this), this.lockBodyScroll = this.lockBodyScroll.bind(this), 
          this.handleAccept = this.handleAccept.bind(this), this.handlePreferences = this.handlePreferences.bind(this);
        }
        lockBodyScroll() {
          document.body.classList.add("overflow-hidden");
        }
        close() {
          this.classList.add("hidden"), this.classList.remove("block"), document.body.classList.remove("overflow-hidden"), 
          window.dispatchEvent(new CustomEvent("cookie-banner-hidden"));
        }
        show() {
          this.classList.remove("hidden"), this.classList.add("block"), this.lockBodyScroll();
        }
        handleAccept(e) {
          e.preventDefault(), e.stopImmediatePropagation(), window.Cookiebot.submitCustomConsent(!0, !0, !0, !0);
        }
        handlePreferences(e) {
          e.preventDefault(), e.stopImmediatePropagation(), window.Cookiebot.show();
        }
        _handleUrlParameters() {
          const e = new URLSearchParams(window.location.search);
          if (!e.has("mbfcb")) return !1;
          const t = "true" === e.get("mbfcb");
          e.delete("mbfcb");
          const o = e.toString(), i = `${window.location.pathname}${o ? "?" + o : ""}`;
          return window.history.replaceState({}, document.title, i), t;
        }
        async connectedCallback() {
          if (this._handleUrlParameters() && (console.warn("[CookieBanner] Preview mode active. Banner will not be shown."), 
          this.isPreview = !0, this.style.display = "none"), !this.acceptEl || !this.preferencesEl) return console.error("[CookieBanner] is missing required child elements with [data-oz-accept] or [data-oz-preferences] attributes."), 
          void (this.style.display = "none");
          try {
            await (0, n.waitForGlobal)("Cookiebot", 5e3), this._initializeCookiebotIntegration();
          } catch (e) {
            console.error(e.message), this.style.display = "none";
          }
        }
        _initializeCookiebotIntegration() {
          this.isPreview || (this.acceptEl.addEventListener("click", this.handleAccept, !0), 
          this.preferencesEl.addEventListener("click", this.handlePreferences, !0)), window.Cookiebot.hide(), 
          setTimeout(() => {
            document.body.classList.remove("auto-hide-cookiebot");
          }, 200), window.Cookiebot.hasResponse || this.isPreview || this.show(), window.addEventListener("CookiebotOnAccept", this.close), 
          window.addEventListener("CookiebotOnDecline", this.close), window.addEventListener("CookiebotOnDialogDisplay", this.lockBodyScroll);
        }
        disconnectedCallback() {
          this.isPreview || (this.acceptEl.removeEventListener("click", this.handleAccept, !0), 
          this.preferencesEl.removeEventListener("click", this.handlePreferences, !0)), window.removeEventListener("CookiebotOnAccept", this.close), 
          window.removeEventListener("CookiebotOnDecline", this.close), window.removeEventListener("CookiebotOnDialogDisplay", this.lockBodyScroll);
        }
      }
      customElements.define("cookie-banner", e);
    }
  })();
}();